import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { Field } from 'redux-form';
import Loading from '@justgiving/loading';
import Alert from '@justgiving/alert';
import { Trans } from 'react-i18next';

import SelectList from '../FormInputs/SelectList';
import FormError from '../Alert/FormError';
import { renderField } from '../../utils/FormUtils';

const titles = ['Mr', 'Mrs', 'Miss', 'Ms', 'Dr', 'Other'];

class NameForm extends Component {
  static propTypes = {
    fetchData: PropTypes.func.isRequired,
    trackPageView: PropTypes.func.isRequired,
    trackLinkClick: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    resetAppErrors: PropTypes.func.isRequired,
    submitHandler: PropTypes.func.isRequired,
    submitting: PropTypes.bool,
    submitSucceeded: PropTypes.bool,
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    status: PropTypes.shape({
      isFetching: PropTypes.bool.isRequired,
      fetchError: PropTypes.bool.isRequired,
      postError: PropTypes.bool.isRequired,
      errorMessage: PropTypes.string,
    }).isRequired,
  };

  static defaultProps = {
    submitting: false,
    submitSucceeded: false,
    error: false,
  };

  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidMount() {
    const { fetchData, trackPageView } = this.props;
    fetchData();
    trackPageView('name', 'personal details > name');
  }

  componentWillUnmount() {
    this.props.reset();
    this.props.resetAppErrors();
  }

  onSubmit(values) {
    const { trackLinkClick, submitHandler } = this.props;
    trackLinkClick('button', 'personal details > name', 'save');
    return submitHandler(values);
  }

  render() {
    const {
      status,
      handleSubmit,
      submitSucceeded,
      submitting,
      error, // redux-form error
    } = this.props;

    if (status.isFetching) {
      return <Loading size="large" colour="purple" />;
    }

    return (
      <form
        method="POST"
        className="jg-space-mtmd"
        onSubmit={handleSubmit(this.onSubmit)}
      >
        {(status.errorMessage || error) && <FormError error />}
        {submitSucceeded && !status.errorMessage && (
          <Alert
            type="success"
            displayType="inline"
            className="qa-message__success jg-space-mbmd"
          >
            <Trans i18nKey="personalDetails.nameAndTitleUpdated">
              Your name and title have been updated.
            </Trans>
          </Alert>
        )}
        <div className="jg-form-group">
          <label htmlFor="Title" className="jg-form-label form-row">
            <Trans i18nKey="personalDetails.userTitle">Title</Trans>
            <SelectList
              name="Title"
              disabled={status.fetchError}
              data={titles}
              label="Title"
              prompt={'Select a Title'}
              autoComplete="on"
            />
          </label>
          <div className="form-row">
            <label htmlFor="FirstName" className="jg-form-label">
              <Trans i18nKey="personalDetails.firstName">First name</Trans>
              <Field
                name="FirstName"
                disabled={status.fetchError}
                component={renderField}
                type="text"
                label="First Name"
                autoComplete="given-name"
                maxlength="50"
              />
            </label>
          </div>
          <div className="form-row">
            <label htmlFor="LastName" className="jg-form-label">
              <Trans i18nKey="personalDetails.lastName">Last name</Trans>
              <Field
                name="LastName"
                disabled={status.fetchError}
                component={renderField}
                type="text"
                label="Last Name"
                autoComplete="family-name"
                maxlength="50"
              />
            </label>
          </div>
          {submitting ? (
            <button type="submit" className="jg-btn jg-btn--brand" disabled>
              <Loading size="small" colour="white" />
            </button>
          ) : (
            <button
              type="submit"
              disabled={status.fetchError}
              className="jg-btn jg-btn--brand qa-button__submit"
            >
              <Trans i18nKey="personalDetails.save">Save</Trans>
            </button>
          )}
        </div>
      </form>
    );
  }
}

export default NameForm;
